import React from 'react';
import Button from '@material-ui/core/Button';
import { ISubmitButtonProps } from 'react-dropzone-uploader/dist/Dropzone';
import { makeStyles } from '@material-ui/core';
import { useTypedSelector } from '../../../shared/hooks/useTypedSelector';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    button: {
        fontSize: '1rem',
        width: '10rem',
        height: '2rem',
    },
}));

const DropzoneSubmit: React.FC<ISubmitButtonProps> = (props) => {
    const classes = useStyles();

    const { className, style, disabled, content, onSubmit, files } = props;

    const { loading } = useTypedSelector((state) => state.graphicUpload.submit);

    const _disabled =
        files.some((f) =>
            ['preparing', 'getting_upload_params', 'uploading'].includes(
                f.meta.status
            )
        ) ||
        !files.some((f) =>
            ['headers_received', 'done'].includes(f.meta.status)
        );

    const handleSubmit = () => {
        onSubmit(
            files.filter((f) =>
                ['headers_received', 'done'].includes(f.meta.status)
            )
        );
    };

    return (
        <div className={className} style={style}>
            <Button
                className={classes.button}
                variant="contained"
                onClick={handleSubmit}
                disabled={disabled || _disabled}
            >
                {!loading && !(disabled || _disabled) && (
                    <React.Fragment>{content}</React.Fragment>
                )}
                {(loading || disabled || _disabled) && (
                    <React.Fragment>
                        <CircularProgress size="1rem" />
                    </React.Fragment>
                )}
            </Button>
        </div>
    );
};

export default DropzoneSubmit;
